import { Exclude, Expose, Type } from 'class-transformer';
import { JobGeolocationHistoryInterface } from '../interfaces/job-geolocation-history.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsNumber, IsOptional, IsString, IsUUID, Min } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { GeographyPointDto } from '../../common/dto/geography-point.dto';
import { UserDto } from '../../user/dto/user.dto';
import { JobDto } from '../../job/dto/job.dto';

@Exclude()
export class JobGeolocationHistoryDto
  extends CommonEntityDto
  implements JobGeolocationHistoryInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Job ID',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiPropertyOptional({
    type: () => JobDto,
    title: 'Job',
  })
  @Expose()
  job?: JobDto;

  @ApiPropertyOptional({
    type: () => GeographyPointDto,
    title: 'Geo',
    nullable: true,
  })
  @Type(() => GeographyPointDto)
  @IsOptional()
  @Expose()
  geo!: GeographyPointDto | null;

  @ApiPropertyOptional({
    type: 'string',
    title: 'Address 1',
    nullable: true,
  })
  @IsString()
  @IsOptional()
  @Expose()
  address1!: string | null;

  @ApiPropertyOptional({
    type: 'string',
    title: 'Address 2',
    nullable: true,
  })
  @IsString()
  @IsOptional()
  @Expose()
  address2!: string | null;

  @ApiPropertyOptional({
    type: 'string',
    title: 'City',
    nullable: true,
  })
  @IsString()
  @IsOptional()
  @Expose()
  city!: string | null;

  @ApiPropertyOptional({
    type: 'string',
    title: 'State',
    nullable: true,
  })
  @IsString()
  @IsOptional()
  @Expose()
  state!: string | null;

  @ApiPropertyOptional({
    type: 'string',
    title: 'Zip',
    nullable: true,
  })
  @IsString()
  @IsOptional()
  @Expose()
  zip!: string | null;

  @ApiPropertyOptional({
    title: 'Geo Distance Tolerance',
    description: 'Distance tolerance in meters for geolocation matching.',
    nullable: true,
  })
  @IsOptional()
  @IsNumber()
  @Min(0)
  @Expose()
  geoDistanceTolerance!: number | null;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Updated By User ID',
  })
  @IsUUID()
  @Expose()
  updatedByUserId!: string;

  @ApiPropertyOptional({
    type: () => UserDto,
    title: 'Updated By User',
  })
  @Expose()
  updatedByUser?: UserDto;
}
